import {i18nKey} from '@/locales/i18n';
import IconView from '@/assets/icons/ic_view.svg';
import IconDelete from '@/assets/icons/ic_delete.svg';
import IconEdit from '@/assets/icons/ic_edit_gray.svg';

export enum DEPARTMENT_FORM {
  SEARCH = 'search',
  STATUS = 'status',
  EXPIRED_DATE = 'expiredDate',
}

export enum USAGE_DETAIL_FILTER_FORM {
  SEARCH = 'search',
  START_DATE = 'startDate',
  END_DATE = 'endDate',
}

export enum DEPARTMENT_FORM_COMPONENT {
  DEPARTMENT_NAME = 'departmentName',
  DESCRIPTION = 'description',
  CURRENT_MONTH = 'currentMonth',
  NEXT_MONTH = 'nextMonth',
  EXPIRED_DATE = 'expiredDate',
  STATUS = 'status',
  TEMPLATE_LIST = 'templateList',
  BLOCK_LIMIT = 'blockLimit',
}

export const DEFAULT_BLOCK_PER_PACKAGE = 1;

export enum MENU_KEY_DEPARTMENT {
  view = '1',
  edit = '2',
  delete = '3',
}

export const ITEM_ACTION_DEPARTMENT = [
  {
    key: '1',
    label: () => i18nKey.templateScreen.listTemplate.actionText.view,
    icon: IconView,
  },
  {
    key: '2',
    label: () => i18nKey.templateScreen.listTemplate.actionText.edit,
    icon: IconEdit,
  },
  {
    key: '3',
    label: () => i18nKey.templateScreen.listTemplate.actionText.delete,
    icon: IconDelete,
  },
];
